import styled from 'styled-components'

export const ViewComments = styled.button`
  transition: background 0.2s;

  &:hover {
    background-color: var(--gray-300);
  }
`

ViewComments.displayName = 'ViewComments'
